import React from 'react';
import GoogleMapReact from 'google-map-react';
const WorldMarker = ({ text }) => <div><svg style={{marginLeft:-25, marginTop:-25}} width="50" height="50" viewBox="0 0 50 50"><g fill="none"><path fill="#3c9cd7" d="M12.585 21.336l-.585.512-.585-.512C6.499 17.034 4 13.286 4 10a8 8 0 1 1 16 0c0 3.286-2.499 7.034-7.415 11.336z"></path><path fill="#FFF" d="M12 7.444c1.655 0 3 1.348 3 3.002a3.002 3.002 0 0 1-3 2.998c-1.655 0-3-1.347-3-3a3.002 3.002 0 0 1 3-3z"></path></g></svg></div>;

export default class QuoteMapComponent extends React.Component {

    constructor() {
        super();

        this.state ={ center: {lat: 41.015,lng:28.979},waypoints: [undefined, undefined]};
        
    }

    updateMarkers(waypoints,center) {
        this.setState({waypoints,center});
    }

    shouldComponentUpdate(nextProps,nextState) {
        return JSON.stringify(nextState.center) != JSON.stringify(this.state.center) || JSON.stringify(nextState.waypoints[0]) != JSON.stringify(this.state.waypoints[0]) || JSON.stringify(nextState.waypoints[1]) != JSON.stringify(this.state.waypoints[1]);
    }

    render() {
        return <GoogleMapReact 
                    
        bootstrapURLKeys={{ key: "AIzaSyCD3Dtv5bkvNi7UEwnwlqqHW_uQgfqbzPk" }}
      //   defaultCenter={{lat: 41.015,lng:28.979}}
        center={this.state.center}
        defaultZoom={10}
      >
        
        {this.state.waypoints[0] != undefined && <WorldMarker
          lat={this.state.waypoints[0].Point[1]}
          lng={this.state.waypoints[0].Point[0]}
          text="My Marker"
        />}

{this.state.waypoints[1] != undefined && <WorldMarker
          lat={this.state.waypoints[1].Point[1]}
          lng={this.state.waypoints[1].Point[0]}
          text="My Marker"
        />}
        
          
        
      </GoogleMapReact>
    }

}



